import { unwrapResult } from '@reduxjs/toolkit'
import {
  Col,
  Form,
  Input,
  Modal,
  ModalProps,
  Row,
  Tag,
  Cascader as Cascaded,
  notification,
} from 'antd'
import moment from 'moment'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { sleep } from '../../../../utils/SystemUtils'
import { savePatient } from '../../../patient/patientSlice'
import { getAddress } from '../../../registration/register/registerSlice'

export const ReplenishPatientModal = (props: {
  isDiseaseEmpty?: any
  patient?: any
  visible?: any
  registrationId?: any
  treatmentId?: any
  onCancel: () => void
  onOk: () => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [isLoading, setIsLoading] = useState(false)

  const [allList, setAllList] = useState<any[]>() //省市数据

  const [idCardRules, setIdCardRules] = useState<any[]>([
    {
      pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      message: '你的身份证格式不正确',
    },
    {
      max: 18,
      message: '最长18位!',
    },
    { required: true, message: '请输入身份证号' },
  ])

  useEffect(() => {
    if (props?.visible) {
      form.setFieldsValue({
        ...props?.patient,
        area: props?.patient?.provinceCode
          ? [
              Number(props?.patient?.provinceCode),
              Number(props?.patient?.cityCode),
              Number(props?.patient?.contryCode),
            ]
          : [],
      })
    } else {
      form.resetFields()
    }
  }, [props?.visible, props?.patient])

  useEffect(() => {
    //获取省市数据
    dispatch(getAddress())
      .then(unwrapResult)
      .then((res: any) => {
        setAllList(res)
      })
  }, [])

  return (
    <Modal
      title={'补充患者基本信息'}
      visible={props?.visible}
      width={500}
      bodyStyle={{ padding: '20px 30px 20px 15px' }}
      confirmLoading={isLoading}
      onCancel={(e) => {
        props?.onCancel && props?.onCancel()
        form.resetFields()
      }}
      onOk={async (e) => {
          setIsLoading(true)
          try {
            const values = await form.validateFields()
            const newPatient = {
              ...props?.patient,
              ...values,
              id: props?.patient?.id ? props?.patient?.id : 0, //快速开单没有传0
              area: undefined,
              provinceCode: values?.area?.[0],
              cityCode: values?.area?.[1],
              contryCode: values?.area?.[2],
            }
            await dispatch(
              savePatient({
                patient: newPatient,
                registrationId: props?.registrationId,
                treatmentId: props?.treatmentId,
              })
            )
              .then(unwrapResult)
              .then((res: any) => {
                props?.onOk && props?.onOk()
                notification.success({
                  message:'操作成功'
                })
              })
              .catch(() => {
                props?.onOk && props?.onOk()
              })
          } catch {
            //
          } finally {
            setIsLoading(false)
          }
      }}
    >
      <Col>
        <Form
          form={form}
          autoComplete='off'
          colon={false}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                name='idCardNumber'
                label='身份证号'
                rules={idCardRules}
              >
                <Input placeholder='请输入身份证号' />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name='phone'
                label='联系方式'
                rules={[
                  { required: true, message: '请输入联系方式' },
                  {
                    pattern: /^[0-9-]*$/,
                    message: '请输入正确的联系方式',
                  },
                ]}
              >
                <Input maxLength={11} placeholder='请输入联系方式' />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name='area'
                label='家庭地区'
                rules={[{ required: true, message: '请选择家庭地区' }]}
              >
                <Cascaded
                  allowClear
                  // loadData={loadData}
                  options={allList}
                  placeholder='请选择家庭地区'
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name='address'
                label='详细地址'
                rules={[
                  { required: true, message: '请输入详细地址' },
                  {
                    max: 250,
                    message: '最长250位!',
                  },
                ]}
              >
                <Input placeholder='请输入详细地址' />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Col>
    </Modal>
  )
}
